import {
    applyBrandTheme,
    getBrandThemeOptions,
    normalizeBrandThemeKey,
    getStoredBrandTheme,
} from "../../helpers/app/BrandTheme";
import {
    applyThemeMode,
    initializeThemeMode,
    isDarkThemeMode,
    THEME_MODE_DARK,
    THEME_MODE_LIGHT,
} from "../../helpers/app/ThemeMode";

export default {
    data() {
        return {
            darkMode: false,
        };
    },
    computed: {
        brandThemeOptions() {
            return getBrandThemeOptions().map((theme) => ({
                ...theme,
                label: this.$t ? this.$t(theme.labelKey) : theme.labelKey,
            }));
        },
        activeBrandTheme() {
            return normalizeBrandThemeKey(this.$store?.state?.theme?.brandTheme || getStoredBrandTheme());
        },
        currentBrandTheme() {
            return this.brandThemeOptions.find((theme) => theme.key === this.activeBrandTheme) || this.brandThemeOptions[0];
        }
    },
    watch: {
        darkMode(value) {
            applyThemeMode(value ? THEME_MODE_DARK : THEME_MODE_LIGHT, this.$store);
        }
    },
    mounted() {
        const themeMode = initializeThemeMode(this.$store);
        this.darkMode = isDarkThemeMode(themeMode);

        this.setBrandTheme(getStoredBrandTheme());
    },
    methods: {
        toggleDarkMode() {
            this.darkMode = !this.darkMode;
        },
        setBrandTheme(themeKey) {
            const appliedTheme = applyBrandTheme(themeKey);

            if (this.$store?.state?.theme) {
                if (typeof this.$store.commit === 'function') {
                    this.$store.commit('SET_BRAND_THEME', appliedTheme);
                } else {
                    this.$store.state.theme.brandTheme = appliedTheme;
                }
            }
        }
    }
}
